var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main help-center"},[(_vm.loading.length == 0)?_c('router-view'):_c('loading',{staticClass:"full-page"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }